export default __webpack_public_path__ + "static/media/0104.d380fdc0.jpg";